import { useEffect, useState } from "react"
import { findDOMNode as findSlateDOMNode } from "@convertkit/slate-react"

export default function useSlateDOMNode(block) {
  const [node, setNode] = useState(null)

  useEffect(() => {
    let node = null
    try {
      node = block && findSlateDOMNode(block)
    } catch (e) {
      console.warn("Error finding DOM node", e)
    }
    setNode(node)
  }, [block])

  return node
}
